import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";

import { loaderHandler } from "src/lib/loaderHandler";

export const Route = createFileRoute("/_auth/_coach")({
  component: RouteComponent,
  ssr: true,
  loader() {
    return loaderHandler((ctx) => {
      const session = ctx.session;

      if (!session?.coach) {
        throw redirect({
          to: "/",
        });
      }
    });
  },
});

function RouteComponent() {
  return <Outlet />;
}
